import React from 'react';
import { Label } from '@zaiusinc/hera';
import styles from './TreeFieldMappingsTable.module.sass';

/**
 * Skeleton loader for the field mappings table
 * Displayed while field mapping mode is loading
 */
export const FieldMappingsTableSkeleton: React.FC = () => {
  return (
    <div className={styles.container}>
      <Label
        label="Field Mappings"
        subLabel="Field mappings connect source fields with matching destination fields."
      >
        <></>
      </Label>

      {/* Search and filter skeleton */}
      <div className={styles.searchContainer}>
        <div className={styles.searchInputWrapper}>
          <div className={styles.skeleton} style={{ height: 30 }} />
        </div>
        <div className={styles.skeleton} style={{ width: 150, height: 30 }} />
      </div>

      {/* Table skeleton */}
      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead className={styles.tableHead}>
            <tr>
              <th className={styles.tableHeader} style={{ width: 300 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <div className={styles.skeleton} style={{ width: 24, height: 24, borderRadius: '4px' }} />
                  <div className={styles.skeleton} style={{ width: 120, height: 12 }} />
                </div>
              </th>
              <th className={styles.tableHeader} style={{ width: 300 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <div className={styles.skeleton} style={{ width: 24, height: 24, borderRadius: '4px' }} />
                  <div className={styles.skeleton} style={{ width: 140, height: 12 }} />
                </div>
              </th>
            </tr>
          </thead>
          <tbody className={styles.tableBody}>
            {[...Array(7)].map((_, i) => (
              <tr key={i} className={styles.tableRow}>
                <td className={styles.tableCell}>
                  <div style={{ padding: '12px 16px' }}>
                    <div className={styles.skeleton} style={{ height: 20 }} />
                  </div>
                </td>
                <td className={styles.tableCell}>
                  <div style={{ padding: '12px 16px' }}>
                    <div className={styles.skeleton} style={{ height: 20 }} />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default FieldMappingsTableSkeleton;
